<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Choose Preferred Plan
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="close"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div class="pref-plan-subheader">
        By selecting a plan as preferred, a label will appear
        on the plan to help consumers choose the most popular plan.
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Select a plan
        </div>
        <div class="ac-row-container">
          <SACDropdown
            class="margin-bottom"
            :options="planOptions"
            :value="planId"
            placeholder="Select Plan"
            field="planId"
            :change="change"
            :error="errObj.planErr"
          />
        </div>
      </div>
    </div>
    <div class="pref-plan-ft-container">
      <button
        type="button"
        class="secondary-button"
        @click="close"
      >
        Cancel
      </button>
      <button
        type="button"
        class="primary-button"
        @click="savePreferredPlan"
      >
        Save
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import providerPlanMixin from '@shared/mixins/providerPlanMixin';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'PreferredPlan',
  components: {
    SACDropdown,
    ProcessOverlay,
  },
  mixins: [providerPlanMixin],
  props: {
    close: Function,
    partnerSettings: Object,
    update: Function,
  },
  data() {
    return {
      processing: false,
      planId: null,
      errObj: {},
    };
  },
  computed: {
    planOptions() {
      const plans = this.plans.filter((x) => x.status !== 'Archived').map((p) => ({
        label: p.name,
        value: p.planId,
      }));

      return plans;
    },
  },
  mounted() {
    this.planId = this.partnerSettings?.PREFERRED_PLAN_ID || '';
  },
  methods: {
    change(f, v) {
      this[f] = v;
    },
    async savePreferredPlan() {
      this.processing = true;
      const errObj = {};
      if (!this.planId) {
        errObj.planErr = 'Please enter select one plan';
      }
      if (Object.keys(errObj).length === 0) {
        await this.update({
          PREFERRED_PLAN_ID: this.planId,
        });
        this.$store.dispatch('showSuccessToast', {
          message: 'Success! Your selected plan is now saved as Preferred',
        });
        this.close();
      }
      this.errObj = errObj;
      this.processing = false;
    },
  },
};
</script>

<style lang="scss">
  .pref-plan-subheader {
    color: $N30;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.064px;
    padding-bottom: 32px;
  }

  .pref-plan-ft-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-top: 1px solid $N10;
    padding: 16px 24px;
    gap: 8px;
  }
</style>
